import { data } from '../../svg/Dashboard/data';
import { makeIcon } from '../makeIcon';

export const Dashboard = makeIcon(data, 'dashboard', 'Dashboard');

export default Dashboard;
